// extracted by mini-css-extract-plugin
export default {"root":"_3C1Og","text-block":"_1ENNM","textBlock":"_1ENNM","prefix":"K2GjX"};